// @ts-nocheck
import { useEffect, useMemo } from 'react'

import { Outlet } from 'react-router-dom'

// Layout Imports
import BlankLayout from '@layouts/BlankLayout'

// Provider Imports
import { SettingsProvider } from '@core/contexts/settingsContext'
import ThemeProvider from '@components/theme'
import AppReactToastify from '@/libs/styles/AppReactToastify'

// Config
import { i18n } from '@configs/i18n'

// Utils
import { getMode, getSettingsFromCookie, getSystemMode } from '@/utils/clientHelpers'

const AuthLayout = () => {
  const lang: 'en' | 'ar' = useMemo(() => {
    try {
      const stored = localStorage.getItem('app-locale')

      return stored === 'ar' ? 'ar' : 'en'
    } catch {
      return 'en'
    }
  }, [])

  const direction = i18n.langDirection[lang]
  const mode = useMemo(() => getMode(), [])
  const settingsCookie = useMemo(() => getSettingsFromCookie(), [])
  const systemMode = useMemo(() => getSystemMode(), [])

  useEffect(() => {
    document.documentElement.lang = lang
    document.documentElement.dir = direction
  }, [lang, direction])

  return (
    <SettingsProvider settingsCookie={settingsCookie} mode={mode}>
      <ThemeProvider direction={direction} systemMode={systemMode}>
        <BlankLayout systemMode={systemMode}>
          <Outlet />
        </BlankLayout>
        <AppReactToastify direction={direction} hideProgressBar />
      </ThemeProvider>
    </SettingsProvider>
  )
}

export default AuthLayout
